export default [
  {
    subTitle:
      'Bizi düşündüren, güldüren ve ağlatan hikayeleri En sevdiğiniz kitabın tadını istediğiniz zaman ve istediğiniz yerde dinleyerek çıkarabilirsiniz.',
    subTitle2: 'KitapDinler tam da bunu yapmanıza olanak sağlar.',
    section: 'section4',
    buttonText2: 'Bilgi Al',
  },
];
